module.exports = __webpack_public_path__ + "img/fa-house.20fbfb6e.svg";